import { parse } from "graphql";
export const getFlagMessageQuery = payload => {
  const allFields = payload.note ? true : false;
  const extraFields = {
    types: ", $note: String, $description: String, $reason: String",
    params: ", note: $note, description: $description, reason: $reason"
  };
  return parse(`
    mutation flagMessage($messageId: String!, $type: String!${allFields ? extraFields.types : ""}) {
        flagMessage(messageId: $messageId, type: $type${allFields ? extraFields.params : ""}) {
            messageId
        }
    }
`);
};